import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/f/cdf';
import __var_2__ from '@stdlib/stats/base/dists/f/ctor';
import __var_3__ from '@stdlib/stats/base/dists/f/entropy';
import __var_4__ from '@stdlib/stats/base/dists/f/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/f/mean';
import __var_6__ from '@stdlib/stats/base/dists/f/mode';
import __var_7__ from '@stdlib/stats/base/dists/f/pdf';
import __var_8__ from '@stdlib/stats/base/dists/f/quantile';
import __var_9__ from '@stdlib/stats/base/dists/f/skewness';
import __var_10__ from '@stdlib/stats/base/dists/f/stdev';
import __var_11__ from '@stdlib/stats/base/dists/f/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace f
*/
var f = {};

/**
* @name cdf
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/cdf}
*/
setReadOnly( f, 'cdf', __var_1__);

/**
* @name F
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/ctor}
*/
setReadOnly( f, 'F', __var_2__);

/**
* @name entropy
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/entropy}
*/
setReadOnly( f, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/kurtosis}
*/
setReadOnly( f, 'kurtosis', __var_4__);

/**
* @name mean
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/mean}
*/
setReadOnly( f, 'mean', __var_5__);

/**
* @name mode
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/mode}
*/
setReadOnly( f, 'mode', __var_6__);

/**
* @name pdf
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/pdf}
*/
setReadOnly( f, 'pdf', __var_7__);

/**
* @name quantile
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/quantile}
*/
setReadOnly( f, 'quantile', __var_8__);

/**
* @name skewness
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/skewness}
*/
setReadOnly( f, 'skewness', __var_9__);

/**
* @name stdev
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/stdev}
*/
setReadOnly( f, 'stdev', __var_10__);

/**
* @name variance
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/variance}
*/
setReadOnly( f, 'variance', __var_11__);


// EXPORTS //
export default f;

export { __var_1__ as cdf, __var_2__ as F, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as mean, __var_6__ as mode, __var_7__ as pdf, __var_8__ as quantile, __var_9__ as skewness, __var_10__ as stdev, __var_11__ as variance};